let currentPage,
    facilities,
    currentFacility,
    currentKey,
    currentService,
    allServices,
    allAddons,
    totalTime,
    availableTimes,
    chosenDate,
    order,
    orderId;
let currentAddons = [];
let totalPrice = 0;
let mileage = 0;
let message = "";
let serviceCode = "";
let currentInfo = {};
let block = document.querySelector(".kobra-block");

export function getCurrentPage() {
    return currentPage;
}
export function setCurrentPage(page) {
    currentPage = page;
    block.querySelector(".page--active").classList.remove("page--active");
    block.querySelector(".page--" + page).classList.add("page--active");
}

export function getInfo() {
    return currentInfo;
}
export function setInfo(info) {
    if (block) {
        block.querySelector("#footer-regno").innerHTML = info.regno;
        block.querySelector("#footer-model").innerHTML = info.brand + ", " + info.model;
    }
    info.mileage = mileage;
    currentInfo = info;
}

export function getLoader(big = false) {
    if (big) {
        return '<div class="loading-wrapper big"><div class="loading"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div></div>';
    }
    return '<div class="loading-wrapper"><div class="loading"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div></div>';
}

export function getFacilities() {
    return facilities;
}
export function getKey() {
    return currentKey;
}
export async function setFacilities() {
    await fetch("/wp-json/facilities_list/v1/facilities", {
        method: "GET",
        headers: {
            "Content-type": "application/json",
        },
    })
        .then((response) => response.json())
        .then((data) => {
            facilities = data;
        });
}
export function setChosenFacility(facility) {
    currentFacility = getFacilities()[facility];
    if (currentFacility !== undefined) {
        currentKey = currentFacility.key;
    }
}
export function getChosenFacility() {
    return currentFacility;
}

export function getMileage() {
    return currentInfo.mileage;
}
export function setMileage(mile) {
    if (!isNaN(mile)) {
        mileage = mile;
        currentInfo.mileage = mile;
    } else if (!isNaN(parseFloat(mile))) {
        mileage = parseFloat(mile);
        currentInfo.mileage = parseFloat(mile);
    } else {
        mileage = 0;
        currentInfo.mileage = 0;
    }
}

export function getServiceCode() {
    return serviceCode;
}
export function setServiceCode(code) {
    serviceCode = code;
}

export function getMessage() {
    return message;
}
export function setMessage(msg) {
    message = msg;
}

export function getService(id) {
    return allServices.filter((service) => service.slug === id);
}
export function getChosenService() {
    return currentService;
}
export function setServices(services) {
    allServices = services;
}
export function setChosenService(service) {
    if (service) {
        currentService = allServices.find((serv) => serv.slug === service.slug || serv.slug === service);
    }
}

export function getAddon(id) {
    return allAddons.find((addon) => addon.slug === id);
}
export function getChosenAddons() {
    return currentAddons;
}
export function setAddons(addons) {
    allAddons = addons;
}
export function setChosenAddons(addon) {
    const existing = currentAddons.findIndex((add) => add.slug === addon.slug);
    if (existing >= 0) {
        currentAddons.splice(existing, 1);
    } else {
        currentAddons.push(addon);
    }
}
export function removeChosenAddons(addon) {
    const existing = currentAddons.findIndex((add) => add.slug === addon.slug);
    if (existing >= 0) {
        currentAddons.splice(existing, 1);
    }
}

export function getTotalPrice() {
    let price = 0;
    if (currentAddons && currentAddons.length > 0) {
        currentAddons.forEach((addon) => {
            if (addon.price) {
                price += parseInt(addon.price);
            }
        });
    }
    if (currentService && currentService.price) {
        price += parseInt(currentService.price);
    }
    return parseInt(price);
}

export function getTotalTime() {
    return totalTime;
}
export function setTotalTime() {
    let time = 0;
    if (currentAddons.length > 0) {
        currentAddons.forEach((addon) => {
            time += parseInt(addon.resourceDemand);
        });
    }
    time += parseInt(currentService.resourceDemand);

    totalTime = parseInt(time);
}
export function setNewTotalTime(time) {
    totalTime = parseInt(time);
}
export function addTime(time) {
    totalTime += parseInt(time);
}
export function removeTime(time) {
    totalTime -= parseInt(time);
}
export function getAvailableTimes() {
    return availableTimes;
}
export function setAvailableTimes(times) {
    availableTimes = times;
}

export function getChosenDate() {
    return chosenDate;
}
export function setChosenDate(date) {
    chosenDate = date;
}

export function getOrder() {
    return order;
}
export function setOrder(ord) {
    order = ord;
}
